<template>
	<el-drawer :modal="false"  title="Filter" :visible.sync="is_visible" class="drawer-filter-cases" size="30%">
		<template slot="title">
			<span role="heading" title="Filter">Filter</span>
		</template>
		<b-container>
			<b-row>
				<b-col cols="12">
					<b-form-group label="Filter by Customer Name">
						<b-form-input v-model="filters.customer_name" placeholder="Type Name" v-on:input="debouncedHandler($event)"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<b-form-group label="Filter by Customer Id">
						<b-form-input v-model="filters.customer_id" placeholder="Type Customer Id" type="number" v-on:input="debouncedHandler($event)"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<b-form-group label="Filter by Case No">
						<b-form-input v-model="filters.case_no" placeholder="Type Case Number" v-on:input="debouncedHandler($event)"></b-form-input>
					</b-form-group>
				</b-col>
				<!-- <b-col cols="12">
					<b-form-group label="Filter by Risk Colour">
						<el-select v-model="filters.risk_color" placeholder="Select">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</b-form-group>
				</b-col> -->
				<!-- <b-col cols="12">
					<b-form-group label="Filter by Disbursement Status">
						<el-select v-model="filters.disbursement_sts" placeholder="Select">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</b-form-group>
				</b-col> -->
				<b-col cols="12">
					<b-form-group label="Filter by Loan Amount">
						<b-form-row>
							<b-col cols="6">
								<b-form-input v-model="filters.loan_amount_min" placeholder="Min. RM" type="number" v-on:input="debouncedHandler($event)"></b-form-input>
							</b-col>
							<b-col cols="6">
								<b-form-input v-model="filters.loan_amount_max" placeholder="Max. RM" type="number" v-on:input="debouncedHandler($event)"></b-form-input>
							</b-col>
						</b-form-row>
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<b-form-group label="Filter by Instalment Amount">
						<b-form-row>
							<b-col cols="6">
								<b-form-input v-model="filters.instalment_amount_min" placeholder="Min. RM" type="number" v-on:input="debouncedHandler($event)"></b-form-input>
							</b-col>
							<b-col cols="6">
								<b-form-input v-model="filters.instalment_amount_max" placeholder="Max. RM" type="number" v-on:input="debouncedHandler($event)"></b-form-input>
							</b-col>
						</b-form-row>
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<b-form-group label="Filter by Credit Officer">
						<el-select v-model="filters.credit_officer_ids" multiple collapse-tags
							placeholder="Select Credit Officer User"
							@change="setFilters()">
							<el-option v-for="item in loanOfficerList" :key="item.id" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</b-form-group>
				</b-col>
				<b-col cols="12">
					<b-form-group label="Filter by SSE">
						<el-select v-model="filters.sse_ids" multiple collapse-tags
							placeholder="Select SSE User"
							@change="setFilters()">
							<el-option v-for="item in sseList" :key="item.id" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</b-form-group>
				</b-col>
			</b-row>
		</b-container>
	</el-drawer>
</template>
<script>
import { Button, Drawer, Select, Option, DatePicker } from 'element-ui'
import { mapState, mapActions } from 'pinia';
import { useLoanCaseStore } from '@/stores/loanCaseStore';
import { useCustomerStore } from '@/stores/customerStore';
import { useAccessControlStore } from '@/stores/accessControlStore';
import { useCommonStore } from '@/stores/commonStore';
import _ from 'lodash';
import moment from 'moment'

export default {
	components: {
		[Button.name]: Button,
		[Drawer.name]: Drawer,
		[Select.name]: Select,
		[Option.name]: Option,
		[DatePicker.name]: DatePicker,
	},
	data() {
		return {
			is_visible: false,
			filters: {
				customer_name: '',
				customer_id: '',
				case_no: '',
				risk_color: '',
				loan_amount_min: '',
				loan_amount_max: '',
				instalment_amount_min: '',
				instalment_amount_max: '',
				credit_officer_ids: [],
				sse_ids: []
			},
			debouncedHandler:''
		}
	},
	computed: {
		...mapState(useCommonStore,['caseStatuses','loanTypes']),
		...mapState(useAccessControlStore,['sseList','loanOfficerList']),
	},	
	created() {
      this.debouncedHandler = _.debounce((val) => {
        if(val.length >= 3 || typeof val == 'number'){
					this.setFilters();
				}
      }, 500);
    },
	methods: {
		show() {
			this.is_visible = !this.is_visible;
		},
		setFilters(){
			this.$emit('filter',this.filters)
		}
	}
}
</script>